import { HomeOwnerWorldPropertyFromValuationFunnelRequest } from '@/stores/types/propertyValuation';

export const FUNNEL_ABANDONMENT_PROPERTY_PAYLOAD_KEY = 'how_funnel_abandonment_property_payload';

export const storeFunnelAbandonmentPropertyPayload = (
  payload: HomeOwnerWorldPropertyFromValuationFunnelRequest,
): void => {
  sessionStorage.setItem(FUNNEL_ABANDONMENT_PROPERTY_PAYLOAD_KEY, JSON.stringify(payload));
};

export const consumeFunnelAbandonmentPropertyPayload =
  (): HomeOwnerWorldPropertyFromValuationFunnelRequest | null => {
    const raw = sessionStorage.getItem(FUNNEL_ABANDONMENT_PROPERTY_PAYLOAD_KEY);
    if (!raw) {
      return null;
    }

    sessionStorage.removeItem(FUNNEL_ABANDONMENT_PROPERTY_PAYLOAD_KEY);

    try {
      return JSON.parse(raw) as HomeOwnerWorldPropertyFromValuationFunnelRequest;
    } catch {
      return null;
    }
  };
